module.exports = __webpack_public_path__ + "media/images/content/share-65ad2344b0632e24240849aa65698058.png";